(function(){
  // Countdown (evergreen, per visitor)
  document.querySelectorAll('[data-pm-timer]').forEach(function(el){
    var hours=parseFloat(el.dataset.hours||'4'),key='pm_timer_end';
    var end=parseInt(localStorage.getItem(key)||'0',10);
    if(!end||end<Date.now()){end=Date.now()+hours*3600000;localStorage.setItem(key,end);}
    var p=function(n){return String(n).padStart(2,'0')};
    var tick=function(){var s=Math.max(0,Math.floor((end-Date.now())/1000));
      el.querySelector('[data-h]').textContent=p(Math.floor(s/3600));
      el.querySelector('[data-m]').textContent=p(Math.floor(s%3600/60));
      el.querySelector('[data-s]').textContent=p(s%60);
      if(s===0){end=Date.now()+hours*3600000;localStorage.setItem(key,end);}};
    tick();setInterval(tick,1000);
  });
  // Mobile nav
  document.querySelectorAll('[data-pm-burger]').forEach(function(b){
    b.addEventListener('click',function(){var n=document.getElementById(b.getAttribute('aria-controls'));n.classList.toggle('is-open');b.setAttribute('aria-expanded',n.classList.contains('is-open'));});
  });
  // Gallery
  document.querySelectorAll('[data-pm-gallery]').forEach(function(g){
    var slides=g.querySelectorAll('.pm-slide'),thumbs=g.querySelectorAll('.pm-thumb');
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){
      slides.forEach(function(s,j){s.classList.toggle('is-active',i===j)});
      thumbs.forEach(function(s,j){s.classList.toggle('is-active',i===j)});
    });});
  });
  // Quantity steppers
  document.querySelectorAll('[data-pm-qty]').forEach(function(q){
    var input=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
      var v=Math.max(1,(parseInt(input.value,10)||1)+parseInt(b.dataset.step,10));input.value=v;input.dispatchEvent(new Event('change'));
    });});
  });
  // Bundles -> quantity + sticky price
  document.querySelectorAll('[data-pm-product]').forEach(function(root){
    var qty=root.querySelector('[data-pm-main-qty]');
    var sp=document.querySelector('[data-pm-sticky-price]'),sc=document.querySelector('[data-pm-sticky-compare]');
    root.querySelectorAll('[data-pm-bundle]').forEach(function(r){
      r.addEventListener('change',function(){
        if(qty)qty.value=r.dataset.qty;
        if(sp)sp.textContent=r.dataset.price;if(sc)sc.textContent=r.dataset.compare;
      });
    });
    var vin=root.querySelector('[data-pm-variant-input]');
    root.querySelectorAll('[data-pm-variant]').forEach(function(r){
      r.addEventListener('change',function(){
        if(vin)vin.value=r.value;
        if(sp)sp.textContent=r.dataset.price;if(sc)sc.textContent=r.dataset.compare;
        var u=new URL(location.href);u.searchParams.set('variant',r.value);history.replaceState(null,'',u);
      });
    });
    // Sticky ATC
    var btn=root.querySelector('[data-pm-atc]'),bar=document.querySelector('[data-pm-sticky]');
    if(btn&&bar&&'IntersectionObserver' in window){
      new IntersectionObserver(function(e){bar.classList.toggle('is-visible',!e[0].isIntersecting&&e[0].boundingClientRect.top<0);}).observe(btn);
    }
  });
  // Before / after
  document.querySelectorAll('[data-pm-ba]').forEach(function(ba){
    var drag=false;
    var set=function(e){var r=ba.getBoundingClientRect();var x=Math.max(0,Math.min(100,(e.clientX-r.left)/r.width*100));ba.style.setProperty('--pos',x+'%');};
    ba.addEventListener('pointerdown',function(e){drag=true;ba.setPointerCapture(e.pointerId);set(e);});
    ba.addEventListener('pointermove',function(e){if(drag)set(e);});
    ba.addEventListener('pointerup',function(){drag=false;});
    ba.addEventListener('keydown',function(e){var v=parseFloat(getComputedStyle(ba).getPropertyValue('--pos'))||50;
      if(e.key==='ArrowLeft')ba.style.setProperty('--pos',Math.max(0,v-5)+'%');if(e.key==='ArrowRight')ba.style.setProperty('--pos',Math.min(100,v+5)+'%');});
  });
  // Load more reviews
  document.querySelectorAll('[data-pm-more]').forEach(function(b){
    b.addEventListener('click',function(){var s=b.closest('section');s.querySelectorAll('.pm-review.is-hidden').forEach(function(r){r.classList.remove('is-hidden')});b.remove();});
  });
})();
